import { COLORS } from '@btime/constants'
import React from 'react'
import { usePdfOptionsForm } from './options/_form/PdfOptionsFormHandler'

export const Table = ({
  style = {},
  center,
  width,
  color,
  useFontBaseColor,
  pageBreakInside,
  fixedLayout,
  children
}) => {
  const { fontBaseColor } = usePdfOptionsForm()

  const selectedColor = useFontBaseColor ? fontBaseColor : color || COLORS.dark4

  style = {
    borderCollapse: 'collapse',
    margin: !!center && 'auto',
    border: `solid 1px ${selectedColor}`,
    pageBreakInside: pageBreakInside ? 'auto' : 'avoid',
    width,
    tableLayout: fixedLayout ? 'fixed' : 'auto',
    ...style
  }

  return <table style={style}>{children}</table>
}

export const TableRow = ({ style = {}, color, useFontBaseColor, children, ...props }) => {
  const { fontBaseColor } = usePdfOptionsForm()

  const selectedColor = useFontBaseColor ? fontBaseColor : color || COLORS.dark4

  style = {
    borderBottom: `solid 1px ${selectedColor}`,
    pageBreakInside: 'avoid',
    pageBreakAfter: 'auto',
    ...style
  }

  return (
    <tr style={style} {...props}>
      {children}
    </tr>
  )
}

export const TableCol = ({ style = {}, color, bgColor, children, useFontBaseColor, ...props }) => {
  const { fontBaseColor } = usePdfOptionsForm()

  const selectedColor = useFontBaseColor ? fontBaseColor : color || COLORS.dark4

  style = {
    borderLeft: `solid 1px ${selectedColor}`,
    padding: '2px 5px',
    backgroundColor: bgColor,
    position: 'relative',
    ...style
  }

  return (
    <td style={style} {...props}>
      {children}
    </td>
  )
}

export const TableHead = ({ style = {}, color, bgColor, children, useFontBaseColor, ...props }) => {
  const { fontBaseColor } = usePdfOptionsForm()

  const selectedColor = useFontBaseColor ? fontBaseColor : color || COLORS.dark4

  style = {
    borderLeft: `solid 1px ${selectedColor}`,
    backgroundColor: bgColor || COLORS.grey + '90',
    padding: '2px 5px',
    ...style
  }

  return (
    <th style={style} {...props}>
      {children}
    </th>
  )
}
